import $ from "jquery";
 
if (typeof window !== "undefined") {
  window.$ = $;
  window.jQuery = $;
  import("owl.carousel");
}
 
import { StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { PromoProvider } from "./Context/PromoContext";
import ScrollToTop from "./utils/ScrollToTop";
import App from "./App.jsx";
import "../src/assets/css/main.css";

const promoData =
  typeof window !== "undefined" && window.__PROMO__
    ? window.__PROMO__
    : [];

function Root() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/vendor/js/bootstrap.bundle.min.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <StrictMode>
      <HelmetProvider>
        <PromoProvider initialData={promoData}>
          <BrowserRouter>
            <ScrollToTop />
            <App />
          </BrowserRouter>
        </PromoProvider>
      </HelmetProvider>
    </StrictMode>
  );
}

hydrateRoot(
  document.getElementById("root"),
  <Root />
);